// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"31":"2ef55ce9df4bd95f","109":"089d7eeb8dd8a9d9","273":"151e7c702a85aa78","373":"e1ccbd665f1473f5","829":"32d960abd0f5ebde"}[chunkId] + ".js";
};